import { useState, useEffect } from 'react';
export const defaultSettings = {
    backgroundColor: 'default',
    backgroundOpacity: 100,
    fontFamily: "'Caveat', cursive",
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: 'normal',
    backgroundStyle: 'soft-gradient',
};
const SETTINGS_STORAGE_KEY = 'diary-settings';
export function useDiarySettings() {
    const [settings, setSettings] = useState(() => {
        const stored = localStorage.getItem(SETTINGS_STORAGE_KEY);
        return stored ? JSON.parse(stored) : defaultSettings;
    });
    useEffect(() => {
        localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
    }, [settings]);
    const resetSettings = () => setSettings(defaultSettings);
    return { settings, setSettings, resetSettings };
}
